import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { WhyHatch } from './components/WhyHatch';
import { Services } from './components/Services';
import { SignatureCallout } from './components/SignatureCallout';
import { BeforeAfter } from './components/BeforeAfter';
import { Process } from './components/Process';
import { ServiceAreas } from './components/ServiceAreas';
import { Reviews } from './components/Reviews';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full overflow-x-hidden bg-[#F9F7EA] font-sans text-[#3F1610]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <WhyHatch data-id="element-5" />
        <Services data-id="element-6" />
        <SignatureCallout data-id="element-7" />
        <BeforeAfter data-id="element-8" />
        <Process data-id="element-9" />
        <ServiceAreas data-id="element-10" />
        <Reviews data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}